"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoBannerType = void 0;
let PromoBannerType = exports.PromoBannerType = /*#__PURE__*/ function(PromoBannerType) {
    PromoBannerType["Image"] = "image";
    PromoBannerType["Video"] = "video";
    PromoBannerType["Text"] = "text";
    PromoBannerType["Split"] = "split";
    return PromoBannerType;
}({});
